// extracted by mini-css-extract-plugin
export default {"time":"ShiftCard_time__1A4UG","hours":"ShiftCard_hours__e95KE"};